<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <strong v-text="`ویرایش ${$lang.exercise_algorithm}`" />
          </div>
          <LoadingSpinner :loading="isLoading" :text="loadingText" />
          <b-form @submit.prevent="save()" v-show="!isLoading">
            <b-form-group
              :label="$lang.caption"
              label-for="caption"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.caption"
                :rules="$v.caption.$params"
              />
              <b-form-input
                id="caption"
                type="text"
                :autocomplete="$lang.caption"
                v-model="$v.caption.$model"
                :state="$v.caption.$dirty ? !$v.caption.$error : null"
              ></b-form-input>

              <b-form-invalid-feedback id="name-feedback"
                >عنوان ضروری است</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group
              class="m-0"
              :label="$lang.run_run_duration"
              label-for="run_duration"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.run_duration"
                :rules="$v.run_duration.$params"
              />
              <b-form-input
                id="run_duration"
                type="number"
                min="5"
                max="600"
                step="5"
                :autocomplete="$lang.run_run_duration"
                v-model="$v.run_duration.$model"
                :state="$v.run_duration.$dirty ? !$v.run_duration.$error : null"
              ></b-form-input>
              <small class="form-text text-muted w-100 text-right">{{
                $lang.minute
              }}</small>

              <b-form-invalid-feedback
                id="run_duration-feedback"
                v-if="!$v.run_duration.required"
              >
                {{
                  $lang.error_required | replace($lang.run_duration)
                }}</b-form-invalid-feedback
              >

              <div
                class="invalid-feedback"
                v-if="$v.run_duration.required && !$v.run_duration.minValue"
              >
                {{ $lang.error_min_value | replace($lang.run_duration, 1) }}
              </div>
            </b-form-group>
            <b-form-group
              :label="$lang.status"
              label-for="status"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.status"
                :rules="$v.is_enable.$params"
              />
              <b-form-checkbox
                v-model="$v.is_enable.$model"
                name="check-button"
                switch
              >
                <b
                  v-if="$v.is_enable.$model"
                  v-text="'فعال'"
                  class="text-success"
                />
                <b v-else v-text="'غیرفعال'" class="text-danger" />
              </b-form-checkbox>
            </b-form-group>
            <DragTable
              :showAlert="true"
              :titleAlert="$lang.ac_ad_exercise_activity_alert"
              :prePage="20"
              :url="activityUrl"
              ref="searchActivity"
              :title="$lang.exerciseAlgorithmDetail"
              :dynamicButtons="buttons"
              :keyLang="`activity_detail_fields`"
              :order_url="`activity/order`"
              :order_by="`order:asc`"
              :permissionButtons="permissions"
              @edit-item="changeActivity"
              :editRoute="true"
              :removeLabel="$lang.exercise_remove"
              :remove_item="removeActivity"
              :hasAdd="isAdmin(permissions, ['admin'])"
              @handleAdd="addActivity"
            />
            <b-modal
              no-close-on-backdrop
              variant="primary"
              header-bg-variant="primary"
              content-class="border-primary"
              v-model="view_activity"
              size="xl"
              ok-only
              hide-footer
              hide-header
            >
              <b-card>
                <div slot="header">
                  <strong v-text="activityFormTitle" />
                </div>
                <LoadingSpinner
                  :loading="modalLoading"
                  :text="modalLoadingText"
                />
                <ActivityForm
                  v-if="!modalLoading"
                  :itemId="itemActivityId"
                  :parentId="algorithm_id"
                  :mode="mode_activity"
                  :permissionBtn="isAdmin(permissions)"
                  :keyAction="keyAction"
                  :keyService="keyService"
                  :keyIndex="keyIndex"
                  :showUpload="true"
                  :showStateDefine="false"
                  :showActivityTiming="false"
                  @submit="submit"
                  @cancel="closeActivityModal"
                  @setResponseCode="setResponseCode"
                />
              </b-card>
            </b-modal>
            <div slot="footer" class="form-group form-btn mt-3">
              <b-button
                type="submit"
                v-if="isAdmin(permissions)"
                size="md"
                variant="success"
              >
                <i class="fa fa-check"></i>
                {{ $lang.submitButton }}
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="handleBack"
              >
                <i class="fa fa-ban"></i>
                {{ $lang.cancelButton }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import DragTable from "@/components/base/dragTable";
import ActivityForm from "@/components/base/ActivityForm";
import { required, minValue } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { isAdmin, generateApiUrl, toastAlert } from "@/shared/utils";

export default {
  name: "edit-algorithm",
  inject: ["attachmentTempFinalRepository"],
  components: {
    LoadingSpinner,
    DragTable,
    ActivityForm,
  },
  validations: {
    caption: {
      required,
    },
    run_duration: {
      required,
      minValue: minValue(1),
    },
    is_enable: {},
  },
  props: {
    mode: {
      type: String,
      default: "add",
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      exercise_id: +this.$route.params.id,
      algorithm_id: +this.$route.params.algorithm_id,
      permissions: [],
      isLoading: false,
      caption: "",
      order: null,
      is_enable: false,
      buttons: [
        {
          id: "0",
          name: "edit",
          click: this.changeActivity,
        },
        {
          id: "1",
          name: "view",
          click: this.changeActivity,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      run_duration: null,
      keyAction: "exercise",
      keyService: "activity",
      keyIndex: "exercise_algorithm",
      responseCode: [],
      itemActivityId: null,
      mode_activity: "add",
      view_activity: false,
      modalLoading: false,
      modalLoadingText: this.$lang.receiving_data,
      loadingText: this.$lang.receiving_data,
    };
  },
  computed: {
    activityUrl() {
      return generateApiUrl(
        ["kanoon", "activity"],
        [this.keyIndex, this.algorithm_id]
      );
    },
    activityFormTitle() {
      return this.mode_activity === "add"
        ? this.$lang.addActivity
        : this.$lang.editActivity;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    closeActivityModal() {
      this.mode_activity = "add";
      this.view_activity = false;
      this.itemActivityId = null;
    },
    addActivity() {
      this.mode_activity = "add";
      this.view_activity = true;
      this.itemActivityId = null;
    },
    changeActivity(item) {
      this.mode_activity = "edit";
      this.view_activity = true;
      this.itemActivityId = pathOr(null, ["id"], item);
    },
    afterSave() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.closeActivityModal();
      }
    },
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1 ? this.$router.go(-1) : window.close();
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      try {
        this.loadingText = this.$lang.sending_data;
        this.isLoading = true;
        const url = generateApiUrl(
          ["kanoon", "exercise_algorithm_id"],
          [this.exercise_id, this.algorithm_id]
        );
        const payload = {
          caption: this.caption,
          duration: this.run_duration,
          order: this.order,
          is_enable: this.is_enable ? 1 : 0,
        };
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.afterSave();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData() {
      if (!this.exercise_id || !this.algorithm_id) return;

      try {
        this.loadingText = this.$lang.receiving_data;
        this.isLoading = true;
        const url = generateApiUrl(
          ["kanoon", "exercise_algorithm_id"],
          [this.exercise_id, this.algorithm_id]
        );
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        this.permissions = response.data.permissions;
        this.caption = pathOr(null, ["caption"], data);
        this.order = pathOr(null, ["order"], data);
        this.is_enable =
          pathOr(false, ["is_enable"], data) === 1 ? true : false;
        this.run_duration = pathOr(null, ["duration"], data);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async submit(payload, allowAddAttachmentCode = true) {
      try {
        this.modalLoadingText = this.$lang.sending_data;
        this.modalLoading = true;
        let response = null;
        if (this.mode_activity === "add") {
          response = await this.$httpService.post(this.activityUrl, payload);
          const id = pathOr(null, ["data", "data"], response);
          if (id && this.responseCode.length && allowAddAttachmentCode) {
            await this.finalSave(id);
          }
        } else {
          const id = this.itemActivityId;
          const url = generateApiUrl(
            ["kanoon", "activity_id"],
            [this.keyIndex, this.algorithm_id, id]
          );
          response = await this.$httpService.put(url, payload);
        }
        this.$notify.success(response.data.message);
        this.$refs.searchActivity.fetchData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.modalLoading = false;
        this.view_activity = false;
      }
    },
    setResponseCode(code) {
      this.responseCode = code;
    },
    async finalSave(id) {
      try {
        const payload = {
          data: [],
        };
        for (const item of this.responseCode) {
          payload.data.push({
            code: item.code,
            attachment_type_id: 34,
            attachment_type_name: "attachment_type_azmoon_activity",
          });
        }
        const result = await this.attachmentTempFinalRepository.create(
          payload,
          "activity",
          id
        );
        this.$notify.success(result.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    async removeActivity(item) {
      try {
        const activityId = pathOr(null, ["id"], item);
        const url = generateApiUrl(
          ["kanoon", "activity_id"],
          [this.keyIndex, this.algorithm_id, activityId]
        );
        const response = await this.$httpService.delete(url);
        const message = pathOr(null, ["data", "message"], response);
        toastAlert(message);
        this.$refs.searchActivity.fetchData();
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
};
</script>

